import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'takeoff-group-top-nav',
  templateUrl: './top-nav.component.html',
  styleUrls: ['./top-nav.component.css']
})
export class TopNavComponent implements OnInit {
  @Input('module-links') moduleLinks = [];
  background: any = '';
  constructor() {}

  ngOnInit() {}

  toggleBackground() {
    this.background = this.background ? '' : 'primary';
  }

  onTabClick(tabLink) {
    this.moduleLinks = this.moduleLinks.map(i =>
      i.title === tabLink ? { ...i, isActive: true } : { ...i, isActive: false }
    );
  }
}
